import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, ButtonSize, PagePanel } from 'edenred-ui';

import { IVoucherSuccessfulScreen } from '@epi-models/containers/OrderStatus';
import { useMenuDimensions } from '@epi-shared/hooks';

import { routerPaths } from '../../constants/routerPaths';
import { PaymentMethods } from '../../constants/paymentMethods';
import { DownloadInvoiceButton } from '../../components/DownloadInvoiceButton/DownloadInvoiceButton';

export function VoucherSuccessfulScreen({
  isPaymentSuccess,
  getTranslationPath,
  paymentMethod,
  forwardEmail,
  isReceiptOnly,
  paymentId,
  isNewCustomer,
  paymentOnlyFlow,
  goToPage
}: IVoucherSuccessfulScreen) {
  const { t } = useTranslation();
  const { isMobile } = useMenuDimensions();

  return (
    <PagePanel
      title={
        isPaymentSuccess
          ? t(getTranslationPath('title_success_payment'))
          : t(getTranslationPath('title_success'))
      }
    >
      <h2 className="small">{t(getTranslationPath('body_success'))}</h2>
      {paymentMethod === PaymentMethods.PrintInvoicePdf && (
        <h2 className="small">
          {t('containers.order_status.body_reference_number_info')}
        </h2>
      )}
      {isNewCustomer && !paymentOnlyFlow ? (
        <div className="pt-20">
          <h2 className="small">{t('containers.order_status.new_customer')}</h2>
        </div>
      ) : (
        ''
      )}
      <Box
        display="flex"
        flexDirection={isMobile ? 'column' : 'row'}
        gap={3}
        mt={2}
        alignItems={isMobile ? 'unset' : 'flex-end'}
      >
        <div>
          {paymentMethod === PaymentMethods.LinkToOtherPerson ? (
            <h2 className="payment-link small">
              {t('containers.order_status.payment_link')} {forwardEmail}
            </h2>
          ) : (
            <div>
              <h2 className="small">
                {isReceiptOnly
                  ? t('containers.order_status.receipt')
                  : t('containers.order_status.invoice')}
              </h2>
              <DownloadInvoiceButton
                id={paymentId}
                idType="payment"
                className="btn-download"
              >
                <span>
                  {isReceiptOnly
                    ? t('containers.order_status.download_receipt')
                    : t('containers.order_status.download_invoice')}
                </span>
              </DownloadInvoiceButton>
            </div>
          )}
        </div>
        <Box>
          <Button
            id="voucher-success-confirm-btn"
            size={ButtonSize.Medium}
            fullWidth
            className="pull-right"
            onClick={() =>
              paymentOnlyFlow
                ? goToPage(`${routerPaths.home}`)
                : goToPage(`${routerPaths.orderHistory}`)
            }
          >
            {paymentOnlyFlow
              ? t('containers.order_status.return_to_home')
              : t(getTranslationPath('button_success'))}
          </Button>
        </Box>
      </Box>
    </PagePanel>
  );
}
